import { z } from "zod";

// Skema untuk setiap item dalam array 'data'
const SourceOfBookingItemSchema = z.object({
    name: z.string(),
    nb_reservations: z.number(),
    nb_nights: z.string(),
    avg_length_of_stay: z.string(),
    total_earning: z.string(),
    avg_earning: z.string(),
    percentage: z.string(),
});

// Skema untuk objek 'total'
const SourceOfBookingTotalSchema = z.object({
    nb_reservations: z.number(),
    nb_nights: z.number(),
    avg_length_of_stay: z.string(),
    total_earning: z.string(),
    avg_earning: z.string(),
    percentage: z.number(),
});

// Skema untuk keseluruhan objek 'data' yang berisi array dan total
const CmSourceOfBookingDataSchema = z.object({
    data: z.array(SourceOfBookingItemSchema),
    total: SourceOfBookingTotalSchema,
});

// Skema untuk seluruh respons API
const CmSourceOfBookingResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
}).merge(CmSourceOfBookingDataSchema); // Menggabungkan data dan total langsung ke level atas

// Ekspor tipe data yang di-infer dari skema
type CmSourceOfBookingResponse = z.infer<typeof CmSourceOfBookingResponseSchema>;
type CmSourceOfBookingData = z.infer<typeof CmSourceOfBookingDataSchema>;

export { CmSourceOfBookingResponseSchema };
export type { CmSourceOfBookingResponse, CmSourceOfBookingData };